import { SystemPermissionModel } from '../../models/SystemPermissionModel';
import { ActionBase } from '../../../core/store/action/ActionBase';

export const REMOVE_PERMISSION_TO_ROLE = '[Security] Remove Add Permission';

export class RemovePermissionToRoleAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = REMOVE_PERMISSION_TO_ROLE;

  constructor(public payload: { roleKey: string, permission: SystemPermissionModel }) { }
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/RemovePermissionToRoleAction.ts